import comp from '../components/barrel';
import svg from '../js/svg';

const EP = 'users/get-comms-log';
const VAR_COMMS_PAGE = 'commsLog_selected_page';
const VAR_COMMS_PAGE_SIZE = 'commsLog_page_size';
const VAR_FILTER_LOG = 'commsLog_filter_log_status';
const VAR_FILTER_SEND = 'commsLog_filter_send_status';
/** POST filter keys align with distinct_from_users / distinct_target_users */
const VAR_FILTER_FROM_USER = 'commsLog_filter_from_user_uuid';
const VAR_FILTER_TARGET_USER_ROW = 'commsLog_filter_target_user_uuid';

const REQ_KEY_FROM_USER = 'from_user_uuid';
/** Optional: narrow log rows to this recipient (thead); must not duplicate scope `target_user_uuid` */
const REQ_KEY_FILTER_TARGET_ROW = 'filter_target_user_uuid';

/** Log status filter (thead adds blank "All" via selectThead placeholder) */
const COMMS_LOG_STATUS_FILTER_OPTS = [
  {status_value: 'FAILED', short_text: 'FAILED'},
  {status_value: 'PROCESSED', short_text: 'PROCESSED'},
  {status_value: 'PENDING', short_text: 'PENDING'},
];

/** Sent / send status filter */
const COMMS_SEND_STATUS_FILTER_OPTS = [
  {status_value: 'FAILED', short_text: 'FAILED'},
  {status_value: 'SENT', short_text: 'SENT'},
  {status_value: 'PENDING', short_text: 'PENDING'},
];

const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Local time: dd mmm yyyy HH:MM */
function formatCreatedDate(iso) {
  if (iso == null || iso === '') return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const day = String(d.getDate()).padStart(2, '0');
  const month = MONTHS_SHORT[d.getMonth()];
  const year = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${day} ${month} ${year} ${hh}:${mm}`;
}

function escapeHtml(s) {
  const d = document.createElement('div');
  d.textContent = s;
  return d.innerHTML;
}

/** Plain text / pretty JSON for modal and “View error” visibility */
function relayResponseDisplay(row) {
  const r = row.sent_relay_response;
  if (r == null || r === '') {
    return '';
  }
  if (typeof r === 'object') {
    try {
      return JSON.stringify(r, null, 2);
    } catch {
      return String(r);
    }
  }
  return String(r).trim();
}

/** Modal title HTML: subject plain, or italic [log_template_name], with optional error prefix */
function commsModalTitleHtml(row, kind) {
  const subj = row.subject != null ? String(row.subject).trim() : '';
  const tpl = row.log_template_name != null ? String(row.log_template_name).trim() : '';
  const esc = escapeHtml;

  if (kind === 'body') {
    if (subj !== '') return esc(subj);
    if (tpl !== '') return `<em>[${esc(tpl)}]</em>`;
    return esc('Message body');
  }
  if (kind === 'log') {
    if (subj !== '') return `Log error — ${esc(subj)}`;
    if (tpl !== '') return `Log error — <em>[${esc(tpl)}]</em>`;
    return 'Log error';
  }
  if (kind === 'relay') {
    if (subj !== '') return `Relay error — ${esc(subj)}`;
    if (tpl !== '') return `Relay error — <em>[${esc(tpl)}]</em>`;
    return 'Relay error';
  }
  return esc('Error detail');
}

function fillSubjectCell(td, row) {
  const subj = row.subject != null ? String(row.subject).trim() : '';
  const tpl = row.log_template_name != null ? String(row.log_template_name).trim() : '';
  if (subj !== '') {
    td.textContent = subj;
    return;
  }
  if (tpl !== '') {
    const em = document.createElement('em');
    em.textContent = `[${tpl}]`;
    td.appendChild(em);
    return;
  }
  td.textContent = '—';
}

function fillPersonCell(cell, name, email) {
  const n = name != null && String(name).trim() !== '' ? String(name) : '';
  const e = email != null && String(email).trim() !== '' ? String(email) : '';
  if (!n && !e) {
    cell.textContent = '—';
    return;
  }
  if (n) {
    cell.appendChild(document.createTextNode(n));
  }
  if (n && e) {
    cell.appendChild(document.createElement('br'));
  }
  if (e) {
    cell.appendChild(document.createTextNode(e));
  }
}

function fillTestingYnCell(td, row) {
  td.className = 'comms-log-testing-cell';
  if (row.testing_yn !== true) {
    return;
  }
  const wrap = document.createElement('span');
  wrap.setAttribute('title', 'Test email');
  wrap.setAttribute('role', 'img');
  wrap.setAttribute('aria-label', 'Test email');
  wrap.className = 'inline-flex text-amber-600';
  wrap.appendChild(svg.mailCheckBadge());
  td.appendChild(wrap);
}

function appendViewErrorButton(cell, page, kind, row, raw) {
  const text = raw != null ? String(raw).trim() : '';
  if (!text) {
    cell.textContent = '—';
    return;
  }
  const viewBtn = document.createElement('button');
  viewBtn.type = 'button';
  viewBtn.className = 'btn-outline comms-log-view-body-btn';
  viewBtn.textContent = 'View error';
  viewBtn.addEventListener('click', (e) => {
    e.preventDefault();
    page.showContentModal(commsModalTitleHtml(row, kind), text, false, true);
  });
  cell.appendChild(viewBtn);
}

function initCommsLogFilterVars() {
  if (thsPage.vars[VAR_FILTER_LOG] === undefined) {
    thsPage.vars[VAR_FILTER_LOG] = '';
  }
  if (thsPage.vars[VAR_FILTER_SEND] === undefined) {
    thsPage.vars[VAR_FILTER_SEND] = '';
  }
  if (thsPage.vars[VAR_FILTER_FROM_USER] === undefined) {
    thsPage.vars[VAR_FILTER_FROM_USER] = '';
  }
  if (thsPage.vars[VAR_FILTER_TARGET_USER_ROW] === undefined) {
    thsPage.vars[VAR_FILTER_TARGET_USER_ROW] = '';
  }
}

/** POST body: target_user_uuid (scope), page, limit; optional log_status, send_status, from_user_uuid, filter_target_user_uuid */
function buildCommsLogPayload() {
  initCommsLogFilterVars();
  const payload = {
    target_user_uuid: thsPage.vars.target_user_uuid,
    page: thsPage.vars[VAR_COMMS_PAGE],
    limit: thsPage.vars[VAR_COMMS_PAGE_SIZE] || 25,
  };
  const logSt = String(thsPage.vars[VAR_FILTER_LOG] || '').trim();
  if (logSt !== '') {
    payload.log_status = logSt;
  }
  const sendSt = String(thsPage.vars[VAR_FILTER_SEND] || '').trim();
  if (sendSt !== '') {
    payload.send_status = sendSt;
  }
  const fromU = String(thsPage.vars[VAR_FILTER_FROM_USER] || '').trim();
  if (fromU !== '') {
    payload[REQ_KEY_FROM_USER] = fromU;
  }
  const targetU = String(thsPage.vars[VAR_FILTER_TARGET_USER_ROW] || '').trim();
  if (targetU !== '') {
    payload[REQ_KEY_FILTER_TARGET_ROW] = targetU;
  }
  return payload;
}

export default {
  async prepare() {
    initCommsLogFilterVars();
    if (thsPage.vars[VAR_COMMS_PAGE] == null || thsPage.vars[VAR_COMMS_PAGE] < 1) {
      thsPage.vars[VAR_COMMS_PAGE] = 1;
    }
    this.recipe.methods.push(await O.mPOST(EP, buildCommsLogPayload()));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    const res = data[EP];
    await this.loadPageFromResponse(res);
  },

  async loadPageFromResponse(res) {
    const rows = res && res.data && Array.isArray(res.data) ? res.data : [];
    const pagination = res && res.pagination ? res.pagination : null;

    this.commsDistinctFromUsers =
      res && Array.isArray(res.distinct_from_users) ? res.distinct_from_users : [];
    this.commsDistinctTargetUsers =
      res && Array.isArray(res.distinct_target_users) ? res.distinct_target_users : [];

    await this.buildTableHead();
    await this.buildTableBody(rows);

    if (pagination) {
      if (pagination.current_page != null) {
        thsPage.vars[VAR_COMMS_PAGE] = Number(pagination.current_page);
      }
      if (pagination.page_size != null) {
        thsPage.vars[VAR_COMMS_PAGE_SIZE] = Number(pagination.page_size);
      }
      this.updateCommsPaginationInfo(pagination);
      await this.buildCommsPagination(pagination);
    } else {
      this.clearCommsPagination();
    }

    this.wireCommsLogFilterListeners();

    window.thsSubTab = this;
  },

  wireCommsLogFilterListeners() {
    const logSel = U.id('commsLogLogStatusDD');
    const sendSel = U.id('commsLogSendStatusDD');
    const recipientSel = U.id('commsLogRecipientDD');
    const senderSel = U.id('commsLogSenderDD');
    if (!logSel || !sendSel) {
      return;
    }
    initCommsLogFilterVars();
    logSel.value = thsPage.vars[VAR_FILTER_LOG];
    sendSel.value = thsPage.vars[VAR_FILTER_SEND];
    if (recipientSel) {
      recipientSel.value = thsPage.vars[VAR_FILTER_TARGET_USER_ROW];
    }
    if (senderSel) {
      senderSel.value = thsPage.vars[VAR_FILTER_FROM_USER];
    }
  },

  async onCommsLogStatusFilterChange() {
    const logSel = U.id('commsLogLogStatusDD');
    const sendSel = U.id('commsLogSendStatusDD');
    const recipientSel = U.id('commsLogRecipientDD');
    const senderSel = U.id('commsLogSenderDD');
    initCommsLogFilterVars();
    if (logSel) {
      thsPage.vars[VAR_FILTER_LOG] = logSel.value;
    }
    if (sendSel) {
      thsPage.vars[VAR_FILTER_SEND] = sendSel.value;
    }
    if (recipientSel) {
      thsPage.vars[VAR_FILTER_TARGET_USER_ROW] = recipientSel.value;
    }
    if (senderSel) {
      thsPage.vars[VAR_FILTER_FROM_USER] = senderSel.value;
    }
    thsPage.vars[VAR_COMMS_PAGE] = 1;
    await this.fetchCommsLog();
  },

  updateCommsPaginationInfo(p) {
    const el = U.id('commsLogPaginationInfo');
    if (!el) {
      return;
    }
    const totalCount = p.total_count != null ? p.total_count : '—';
    const cur = p.current_page != null ? p.current_page : '—';
    const totalPages = p.total_pages != null ? p.total_pages : '—';
    const pageSize = p.page_size != null ? p.page_size : '—';
    el.textContent = `Total ${totalCount} records · Page ${cur} of ${totalPages} · ${pageSize} per page`;
  },

  clearCommsPagination() {
    const wrap = U.id('commsLogPaginationWrapper');
    if (wrap) {
      wrap.innerHTML = '';
    }
    const info = U.id('commsLogPaginationInfo');
    if (info) {
      info.textContent = '';
    }
    const container = U.id('commsLogPaginationContainer');
    if (container) {
      U.hide('commsLogPaginationContainer');
    }
  },

  async buildCommsPagination(paginationState) {
    const container = U.id('commsLogPaginationContainer');
    const wrapper = U.id('commsLogPaginationWrapper');
    if (!container || !wrapper) {
      return;
    }

    const totalPages = Number(paginationState.total_pages) || 0;
    if (totalPages < 1) {
      wrapper.innerHTML = '';
      U.hide('commsLogPaginationContainer');
      return;
    }

    U.unhide('commsLogPaginationContainer');
    wrapper.innerHTML = '';

    const prevSavedPage = thsPage.vars.selected_page;
    thsPage.vars.selected_page = thsPage.vars[VAR_COMMS_PAGE];
    await comp.paginationButtons({totalPages, wrapperID: 'commsLogPaginationWrapper'});
    thsPage.vars.selected_page = prevSavedPage;

    const page = this;
    wrapper.querySelectorAll('.pageButton').forEach((button) => {
      button.addEventListener('click', (e) => {
        const v = Number(e.currentTarget.getAttribute('value'));
        if (!Number.isFinite(v) || v < 1) {
          return;
        }
        thsPage.vars[VAR_COMMS_PAGE] = v;
        page.fetchCommsLog();
      });
    });
  },

  async fetchCommsLog() {
    try {
      comp.loader(1);
      const res = await O.PREP([await O.mPOST(EP, buildCommsLogPayload())]);
      const payload = res[EP];
      await this.loadPageFromResponse(payload);
    } catch (_e) {
      // keep existing table; errors surfaced elsewhere if needed
    } finally {
      comp.loader(0);
    }
  },

  async buildTableHead() {
    const tableHead = U.id('commsLogTableHead');
    tableHead.innerHTML = '';
    const headRow = tableHead.insertRow();

    const createdTh = headRow.insertCell();
    createdTh.innerHTML = 'Created';
    const testingTh = headRow.insertCell();
    testingTh.innerHTML = '&nbsp;';
    testingTh.className = 'comms-log-testing-head';
    const subjectTh = headRow.insertCell();
    subjectTh.innerHTML = 'Subject';

    const recipientTh = headRow.insertCell();
    if (this.hideCommsRecipientFilter) {
      recipientTh.innerHTML = 'Recipient';
    } else {
      const recipientDd = await comp.selectThead(
        'commsLogRecipientDD',
        this.commsDistinctTargetUsers || [],
        'target_user_uuid',
        'email_address',
        'thsSubTab.onCommsLogStatusFilterChange()',
        'All recipients',
      );
      recipientTh.appendChild(recipientDd);
    }

    const senderTh = headRow.insertCell();
    const senderDd = await comp.selectThead(
      'commsLogSenderDD',
      this.commsDistinctFromUsers || [],
      'from_user_uuid',
      'email_address',
      'thsSubTab.onCommsLogStatusFilterChange()',
      'All senders',
    );
    senderTh.appendChild(senderDd);

    const logStatusTh = headRow.insertCell();
    const logStatusDd = await comp.selectThead(
      'commsLogLogStatusDD',
      COMMS_LOG_STATUS_FILTER_OPTS,
      'status_value',
      'short_text',
      'thsSubTab.onCommsLogStatusFilterChange()',
      'All log statuses',
    );
    logStatusTh.appendChild(logStatusDd);

    const sendStatusTh = headRow.insertCell();
    const sendStatusDd = await comp.selectThead(
      'commsLogSendStatusDD',
      COMMS_SEND_STATUS_FILTER_OPTS,
      'status_value',
      'short_text',
      'thsSubTab.onCommsLogStatusFilterChange()',
      'All sending statuses',
    );
    sendStatusTh.appendChild(sendStatusDd);

    ['Log error', 'Relay error', 'Message'].forEach((label) => {
      const c = headRow.insertCell();
      c.innerHTML = label;
    });
  },

  async buildTableBody(listData) {
    const tbody = U.id('commsLogTableBody');
    tbody.innerHTML = '';
    const page = this;

    if (!listData.length) {
      const tr = tbody.insertRow();
      const cell = tr.insertCell(0);
      cell.colSpan = 10;
      cell.innerHTML = 'No communications log entries found.';
      return;
    }

    for (const row of listData) {
      const tr = tbody.insertRow();

      const createdCell = tr.insertCell();
      createdCell.textContent = formatCreatedDate(row.log_created_date);

      const testingCell = tr.insertCell();
      fillTestingYnCell(testingCell, row);

      const subjectCell = tr.insertCell();
      fillSubjectCell(subjectCell, row);

      const recipientCell = tr.insertCell();
      fillPersonCell(recipientCell, row.recipient_name, row.recipient_email);

      const senderCell = tr.insertCell();
      fillPersonCell(senderCell, row.sender_name, row.sender_email);

      const logStatusCell = tr.insertCell();
      if (row.log_status != null && row.log_status !== '') {
        const tag = await comp.statusTag(String(row.log_status));
        logStatusCell.appendChild(tag);
      } else {
        logStatusCell.textContent = '—';
      }

      const sentStatusCell = tr.insertCell();
      if (row.sent_status != null && row.sent_status !== '') {
        const tag = await comp.statusTag(String(row.sent_status));
        sentStatusCell.appendChild(tag);
      } else {
        sentStatusCell.textContent = '—';
      }

      const logErrCell = tr.insertCell();
      appendViewErrorButton(logErrCell, page, 'log', row, row.log_error);

      const sentErrCell = tr.insertCell();
      appendViewErrorButton(sentErrCell, page, 'relay', row, relayResponseDisplay(row));

      const bodyCell = tr.insertCell();
      const bodyHtml = row.body != null && String(row.body).trim() !== '' ? String(row.body) : '';
      if (!bodyHtml) {
        bodyCell.textContent = '—';
      } else {
        const viewBtn = document.createElement('button');
        viewBtn.type = 'button';
        viewBtn.className = 'btn-outline comms-log-view-body-btn';
        viewBtn.textContent = 'View body';
        viewBtn.addEventListener('click', (e) => {
          e.preventDefault();
          page.showContentModal(commsModalTitleHtml(row, 'body'), bodyHtml, true, true);
        });
        bodyCell.appendChild(viewBtn);
      }
    }
  },

  /**
   * @param {string} titleText - Modal heading (plain or HTML if titleAsHtml)
   * @param {string} content - Body HTML or plain text
   * @param {boolean} isHtml - When false, content is shown as plain text (errors)
   * @param {boolean} [titleAsHtml=false] - When true, titleText is set via innerHTML (italic template fallback)
   */
  showContentModal(titleText, content, isHtml, titleAsHtml) {
    const prev = document.getElementById('commsLogBodyModal');
    if (prev) {
      prev.remove();
    }

    const backdrop = document.createElement('div');
    backdrop.id = 'commsLogBodyModal';
    backdrop.className =
      'fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center p-4';
    backdrop.setAttribute('role', 'dialog');
    backdrop.setAttribute('aria-modal', 'true');

    const onClose = () => {
      document.removeEventListener('keydown', onKey);
      U.closeModal('commsLogBodyModal');
    };

    const onKey = (ev) => {
      if (ev.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKey);

    backdrop.addEventListener('click', (e) => {
      if (e.target === backdrop) {
        onClose();
      }
    });

    const panel = document.createElement('div');
    panel.className =
      'relative w-full max-w-6xl rounded-lg bg-white shadow-xl flex flex-col max-h-[90vh] overflow-hidden';
    panel.addEventListener('click', (e) => e.stopPropagation());

    const header = document.createElement('div');
    header.className =
      'flex shrink-0 items-center justify-between gap-3 border-b border-grey-stroke px-4 py-3 sm:px-6';

    const title = document.createElement('h4');
    title.className = 'text-base font-semibold pr-2 m-0';
    if (titleAsHtml) {
      title.innerHTML = titleText || '—';
    } else {
      title.textContent = titleText || '—';
    }

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'btn-outline shrink-0';
    closeBtn.textContent = 'Close';
    closeBtn.addEventListener('click', () => onClose());

    header.appendChild(title);
    header.appendChild(closeBtn);

    const bodyWrap = document.createElement('div');
    bodyWrap.className =
      'comms-log-modal-body overflow-y-auto px-4 py-4 sm:px-6 text-sm' +
      (isHtml ? '' : ' whitespace-pre-wrap break-words');
    if (isHtml) {
      bodyWrap.innerHTML = content;
    } else {
      bodyWrap.textContent = content;
    }

    panel.appendChild(header);
    panel.appendChild(bodyWrap);
    backdrop.appendChild(panel);
    document.body.prepend(backdrop);
  },

  async savePage(targetId) {
    if (typeof targetId === 'string' && /^VUt_/.test(targetId)) {
      await O.changeSubTab(targetId);
    }
  },
};
